export default __webpack_public_path__ + "static/media/listbuilder-question-selected.9d0e8a70.svg";